var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusPurple2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-296 -1530) translate(94 1468) translate(202 62)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6728FF",
    fillRule: "nonzero",
    d: "M22.012 44c3.007 0 5.837-.575 8.492-1.726 2.655-1.15 4.996-2.739 7.024-4.766 2.028-2.027 3.614-4.367 4.757-7.02C43.428 27.835 44 24.998 44 21.977c0-3.006-.572-5.835-1.715-8.488-1.143-2.653-2.729-4.993-4.757-7.02-2.028-2.028-4.37-3.612-7.024-4.755C27.849.571 25.011 0 21.988 0c-3.007 0-5.837.571-8.492 1.714C10.841 2.857 8.5 4.441 6.472 6.469c-2.028 2.027-3.614 4.367-4.757 7.02C.572 16.142 0 18.97 0 21.977c0 3.02.576 5.858 1.727 8.51 1.15 2.654 2.736 4.994 4.757 7.021 2.02 2.027 4.357 3.616 7.012 4.766C16.151 43.424 18.989 44 22.012 44zm-.047-11.927c-.36 0-.646-.118-.858-.353-.211-.234-.317-.54-.317-.915v-7.608h-7.752c-.376 0-.693-.105-.952-.317-.258-.21-.387-.497-.387-.857 0-.375.125-.673.376-.892.25-.219.571-.328.963-.328h7.752V13.03c0-.376.106-.685.317-.927.212-.243.498-.364.858-.364.376 0 .673.117.892.352.22.235.33.548.33.939v7.772h7.752c.407 0 .728.11.963.328.235.22.352.517.352.892 0 .36-.125.646-.376.857-.25.212-.564.317-.94.317h-7.752v7.608c0 .391-.11.7-.329.927-.219.227-.516.34-.892.34z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusPurple2);
export default __webpack_public_path__ + "static/media/ic_plus_purple_2.4e496b7eef97f618ed96540dab763b56.svg";
export { ForwardRef as ReactComponent };